'use strict';
import {buildLogger} from '../logger';

export const logger = buildLogger('misc-utils');



// WEBPACK FOOTER //
// ./src/js/core-utilities/react-i18n/logger.js